import Vue from 'vue'
import VueI18n from 'vue-i18n'
import en_GB from './en_GB.js'
Vue.use(VueI18n)

const defaultLang = 'en_GB' // 默认语言
const loadedLanguages = ['en_GB']
const setLoadedLanguages = () => localStorage.setItem('loadedLanguages', JSON.stringify(loadedLanguages));
const getLoadedLanguages = () => localStorage.getItem('loadedLanguages') ? JSON.parse(localStorage.getItem('loadedLanguages')) : loadedLanguages;

function arraysEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (let i = 0; i < arr1.length; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}

const i18n = new VueI18n({
    locale: localStorage.getItem('lang') || defaultLang,
    fallbackLocale: defaultLang,
    messages: {
        en_GB: {
            ...en_GB
        }
    },
    silentTranslationWarn: true,
    missing: (locale, key) => {
        console.log('语言map表缺失该语言', locale, key)
    }
})

function setI18nLanguage(lang) {
    i18n.locale = lang
    document.querySelector('html').setAttribute('lang', lang)
    setLoadedLanguages()
    return lang
}

export function loadLanguageAsync(lang) {
    if (arraysEqual(loadedLanguages, getLoadedLanguages())) {
        // 如果语言相同
        if (i18n.locale === lang) {
            return Promise.resolve(setI18nLanguage(lang))
        }

        //如果语言已经加载
        if (loadedLanguages.includes(lang)) {
            return Promise.resolve(setI18nLanguage(lang))
        }
    }
    // 如果尚未加载语言
    return import(/* webpackChunkName: "lang-[request]" */ `@/lang/${lang}.js`).then(
        messages => {
            i18n.setLocaleMessage(lang, messages.default)
            loadedLanguages.push(lang)
            return setI18nLanguage(lang)
        }
    )
}

export default {i18n, loadLanguageAsync}